import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetProductsDocument,
  type GetProductsQuery,
  type GetProductsQueryVariables,
} from "~/features/admin/products/gqls";

/**
 * Loads the full product list. GetProducts is tenant-scoped server-side via the
 * Hasura session (no `tenantId` variable), so the whole list is fetched at once
 * and filtered / paginated client-side — V1 parity.
 */
export function useProductsList() {
  return useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, {
    fetchPolicy: "cache-and-network",
  });
}
